// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0023d504","667":"4b786f7c","977":"5778e9fe"}[chunkId] + ".chunk.js";
};